import ApiBase from 'app/services/api/entities/Base'

function* checkCodeConductPermissions() {
  return yield ApiBase.privateGet('/v1/contract_version/permissions/add_new_property_revision/', {})
}

function* checkConsentType() {
  return yield ApiBase.privateGet('/v1/contract_version/consent_type/add_new_property_revision/', {})
}

function* getDocumentUrl(documentType) {
  return yield ApiBase.privateGet(`/v1/contract_version/documents/${documentType}/pdf_url/`, {})
}

function* acceptCodeConductContract(documentType) {
  return yield ApiBase.privatePost(`/v1/contract_version/documents/${documentType}/agree/`, {})
}

export default {
  checkCodeConductPermissions,
  checkConsentType,
  getDocumentUrl,
  acceptCodeConductContract,
}
